export const API_URL = "https://api.trisaranepal.com/";
// export const API_URL = "http://localhost:8000/";
